import styled from "styled-components";
import { useAppKit } from "@reown/appkit/react";
import { useWallet } from "@bracket/platform/store";
import { getTheme, Button, coins } from "@bracket/ui";
import { formatAddress } from "@formatters";
import type { FunctionComponent } from "react";


export declare type AddressButtonProps = {
	// No additional props needed as the component uses wallet context
};

/**
 * AddressButton component that displays the user's wallet address with chain-specific coin icon
 * and opens the wallet modal when clicked.
 * 
 * @param props - AddressButtonProps
 * @returns JSX.Element | null - The address button component or null if no address/anonymous
 */
export const AddressButton: FunctionComponent<AddressButtonProps> = () => {

	const { open } = useAppKit();
	const { address, chainId, anonymous } = useWallet();

	if (!address || anonymous) {
		return null;
	}

	return (
		<Button
		size="sm" 
		variant="outline"
			label={
				<div>
					{
						chainId === 1 ? <coins.ETH /> :
						chainId === 42161 ? <coins.ARB /> :
						chainId === 200810 ? <coins.BTC /> :
						chainId === 200901 ? <coins.BTC /> :
						null
					}
					{formatAddress(address || "")}
				</div>
			}
			onClick={() => open({ view: "Account" })}
		/>
	);
};



const StyledAddressButton = styled(Button)`
	// color: ${() => getTheme().surface_on};
	// background: ${() => getTheme().surface_container};
	// div {
	// 	display: flex;
	// 	justify-content: center;
	// 	gap: 0.75rem;
	// 	align-items: center;
	// }
`;
